import axios from "axios";
// import { message  } from 'antd'
import store from "../../state/store";
import { actionCreators } from "../../state/ducks/root";
import { apiRefreshToken } from "../../api/member";
import navigateToPage from "../../utils/navigate";

import { apiBaseURL } from "../../config";

// 创建axios实例
const defaultConfig = {
  baseURL: apiBaseURL,
  timeout: 6000,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
  },
};

console.log("defaultConfig", defaultConfig);

//const mergedConfig = { ...defaultConfig, ...config }
const service = axios.create(defaultConfig);

let requestList = [];
let isRefreshToken = false;

// request拦截器
service.interceptors.request.use(
  (config) => {
    // message.error('登录失败，请重试-111111')
    //message.error('登录失败，请重试-111112')
    //console.log(useUserStore.getState().userInfo)
    config.headers.Accept = "*/*";
    config.headers["tenant-id"] = "1";
    config.headers["terminal"] = "20";
    const token = getToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => {
    // 如果是 /auth/ 下的 URL 地址，并且返回了 accessToken 说明是登录相关的接口，则自动设置登陆令牌
    const url = response.config.url || "";
    if (url.indexOf("/member/auth/") >= 0 && response.data?.data?.accessToken) {
      //console.log('到这里来了====')
      store.dispatch(
        actionCreators.user.setUserLogin({
          isLogin: true,
          token: response.data.data.accessToken,
          refreshToken: response.data.data.refreshToken,
          userId: response.data.data.userId,
        }),
      );
    }
    // if(url.indexOf('/member/auth/test') >= 0){
    // 	console.log('test这里来了====')
    // 	//return Promise.reject('错误了11111')
    // 	//return refreshToken(response.config)

    // }
    if (response.data.code === 401) {
      //console.log('Herer-111111-1-start')
      return refreshToken(response.config);
    }
    return response;
  },
  (error) => {
    const apiError = error.response?.data;
    console.log("error=============", error);
    return Promise.reject(apiError);
  },
);

const getToken = () => {
  return store.getState().user.token;
};

const handleAuthorized = () => {
  store.dispatch(actionCreators.user.resetAuthorized());
  navigateToPage("/login");
  return Promise.reject({
    code: 401,
    msg: "您的登陆已过期，请重新登录",
  });
};

const refreshToken = async (config) => {
  // 如果当前已经是 refresh-token 的 URL 地址，并且还是 401 错误，说明是刷新令牌失败了，直接返回 Promise.reject(error)
  if (config.url.indexOf("/member/auth/refresh-token") >= 0) {
    return Promise.reject('error');
  }

  // 如果未认证，并且未进行刷新令牌，说明可能是访问令牌过期了
  if (!isRefreshToken) {
    isRefreshToken = true;
    // 1. 如果获取不到刷新令牌，则只能执行登出操作
    const refreshToken = store.getState().user["refresh-token"];
    if (!refreshToken) {
      return handleAuthorized();
    }
    // 2. 进行刷新访问令牌
    try {
      const res = await apiRefreshToken(refreshToken);
      if (res.code !== 0) {
        //console.log('刷新令牌失败-开始')
        // 如果刷新不成功，直接抛出 e 触发 2.2 的逻辑
        throw new Error("刷新令牌失败");
      }
      // 2.1 刷新成功，则回放队列的请求 + 当前请求
      config.headers.Authorization = "Bearer " + store.getState().user.token;
      requestList.forEach((cb) => {
        cb();
      });
      requestList = [];
      console.log("开始回放请求了1。。。。");
      return service.request(config);
    } catch (error) {
      // 为什么需要 catch 异常呢？刷新失败时，请求因为 Promise.reject 触发异常。
      // 2.2 刷新失败，只回放队列的请求
      requestList.forEach((cb) => {
        cb();
      });
      console.log("回放请求失败了。。。。");
      // 提示是否要登出。即不回放当前请求！不然会形成递归
      return handleAuthorized();
    } finally {
      requestList = [];
      isRefreshToken = false;
    }
  } else {
    // 添加到队列，等待刷新获取到新的令牌
    requestList.push(() => {
      return new Promise((resolve) => {
        requestList.push(() => {
          config.headers.Authorization =
            "Bearer " + store.getState().user.token; // 让每个请求携带自定义token 请根据实际情况自行修改
          resolve(service.request(config));
        });
      });
    });
  }
};

export { service };
